/**
 * CurrentUsers.js - Типы действий для добавления данных о количестве пользователей в хранилище
 * @module constants/CurrentUsers
 * */

export const SET_CURRENT_USERS = 'SET_CURRENT_USERS'
export const SET_AVG_VIEWTIME = 'SET_AVG_VIEWTIME'
export const SET_RECIRCULATION = 'GET_AVG_RECIRCULATION'



// WEBPACK FOOTER //
// ./src/constants/CurrentUsers.js